'use client';

import { useEffect, useRef } from 'react';

import { envConfig } from '@/config/env';

type ProductPageWalleyWidgetScriptProps = {
    serviceLocale: string;
    walleyToken?: string;
    variantPrice?: number;
};

export default function ProductPageWalleyWidgetScript({
    serviceLocale,
    walleyToken,
    variantPrice,
}: ProductPageWalleyWidgetScriptProps) {
    const ref = useRef<HTMLDivElement | null>(null);

    useEffect(() => {
        if (!ref.current || !variantPrice || !walleyToken) {
            return;
        }

        const scriptElement = ref.current.querySelector('script');

        if (scriptElement) {
            scriptElement.setAttribute(
                'data-amount',
                String(variantPrice * 100),
            );

            window.walley?.checkout?.api?.update?.();

            return;
        }

        const script = document.createElement('script');

        script.setAttribute('src', envConfig.NEXT_PUBLIC_WALLEY_SCRIPT_SOURCE);
        script.setAttribute('data-token', walleyToken);
        script.setAttribute('data-widget', 'part-payment');
        script.setAttribute('data-amount', String(variantPrice * 100));
        script.setAttribute('data-lang', serviceLocale);

        ref.current.appendChild(script);
    }, [walleyToken, serviceLocale, variantPrice]);

    return <div ref={ref} />;
}
